import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ConfirmService} from '@tymes4-shared';
import {ContactModel, Language, LanguageService} from '../../api';
import {AuthService} from '../../services/auth.service';

@Component({
    selector: 'app-edit-customer-primary-account',
    templateUrl: './edit-customer-primary-account.component.html',
    standalone: false
})
export class EditCustomerPrimaryAccountComponent implements OnInit {
  @Input() PrimaryContact: FormGroup;
  @Input() primaryContact: ContactModel;
  @Output() ssoDeleted = new EventEmitter<void>();

  readonly requiredValidator = Validators.required;
  isUsingSASSO: boolean = false;
  SelectableLanguages: Array<Language> = [];
  selectableGenders = [
    {viewValue: this.translate.instant('FANS.EDIT-CUSTOMER-FORM.COMPONENT.CUSTOMER-DETAILS.PRIMARY-ACCOUNT.FORM.DROPDOWN.MALE-SALUTATION'), value: 'M'},
    {viewValue: this.translate.instant('FANS.EDIT-CUSTOMER-FORM.COMPONENT.CUSTOMER-DETAILS.PRIMARY-ACCOUNT.FORM.DROPDOWN.FEMALE-SALUTATION'), value: 'F'},
  ];
  validationMessages = {DateOfBirth: [{type: 'maxDate', message: 'FORM.VALIDATION.INVALIDDOB'}, {type: 'minDate', message: 'FORM.VALIDATION.INVALIDDOB'}]};

  constructor(private languageService: LanguageService,
              private translate: TranslateService,
              private auth: AuthService,
              private confirmService: ConfirmService) {
  }

  ngOnInit() {
    this.languageService.getLanguages().subscribe(languages => this.SelectableLanguages = languages);
    if (this.auth.getLoggedInUser() != null) {
      this.isUsingSASSO = this.auth.getLoggedInUser().SystemSettings['SSOEnabled'].toLowerCase() == 'true';
    }
  }

  deleteSSOId() {
    this.confirmService.confirm({title: this.translate.instant('DIALOG.SSO_REMOVE.CONFIRM.TITLE'), message: this.translate.instant('DIALOG.SSO_REMOVE.CONFIRM.MSG'), okonly: false}).subscribe((confirmed: boolean) => {
      if (!confirmed
        || !this.primaryContact) {
        return;
      }

      this.primaryContact.SSOId = null;
      this.PrimaryContact.patchValue(this.primaryContact);
      this.PrimaryContact.markAsDirty();
      this.PrimaryContact.enable();
      this.ssoDeleted.emit();
    });
  }
}
